"use client";

// Style as confirm component
import _defineProperty from "/builds/elproag/cloud/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { prepareComponentToken, prepareToken } from '.';
import { clearFix } from '../../style';
import { genSubStyleComponent } from '../../theme/internal';
// ============================= Confirm ==============================
var genModalConfirmStyle = function genModalConfirmStyle(token) {
  var _$concat, _confirmComponentCls, _ref;
  var componentCls = token.componentCls,
    titleFontSize = token.titleFontSize,
    titleLineHeight = token.titleLineHeight,
    modalConfirmIconSize = token.modalConfirmIconSize,
    fontSize = token.fontSize,
    lineHeight = token.lineHeight;
  var confirmComponentCls = "".concat(componentCls, "-confirm");
  var titleHeight = Math.round(titleFontSize * titleLineHeight);
  var contentHeight = Math.round(fontSize * lineHeight);
  return _ref = {}, _defineProperty(_ref, confirmComponentCls, (_confirmComponentCls = {
    '&-rtl': {
      direction: 'rtl'
    }
  }, _defineProperty(_confirmComponentCls, "".concat(token.antCls, "-modal-header"), {
    display: 'none'
  }), _defineProperty(_confirmComponentCls, "".concat(confirmComponentCls, "-body-wrapper"), Object.assign({}, clearFix())), _defineProperty(_confirmComponentCls, "".concat(confirmComponentCls, "-body"), (_$concat = {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'start'
  }, _defineProperty(_$concat, "> ".concat(token.iconCls), {
    flex: 'none',
    fontSize: modalConfirmIconSize,
    marginInlineEnd: token.marginSM,
    marginTop: (contentHeight - modalConfirmIconSize) / 2
  }), _defineProperty(_$concat, "&-has-title > ".concat(token.iconCls), {
    marginTop: (titleHeight - modalConfirmIconSize) / 2
  }), _$concat)), _defineProperty(_confirmComponentCls, "".concat(confirmComponentCls, "-paragraph"), {
    display: 'flex',
    flexDirection: 'column',
    flex: 'auto',
    rowGap: token.marginXS,
    maxWidth: "calc(100% - ".concat(token.modalConfirmIconSize + token.marginSM, "px)")
  }), _defineProperty(_confirmComponentCls, "".concat(confirmComponentCls, "-title"), {
    color: token.colorTextHeading,
    fontWeight: token.fontWeightStrong,
    fontSize: titleFontSize,
    lineHeight: titleLineHeight
  }), _defineProperty(_confirmComponentCls, "".concat(confirmComponentCls, "-content"), {
    color: token.colorText,
    fontSize: fontSize,
    lineHeight: lineHeight
  }), _defineProperty(_confirmComponentCls, "".concat(confirmComponentCls, "-btns"), _defineProperty({
    textAlign: 'end',
    marginTop: token.marginSM
  }, "".concat(token.antCls, "-btn + ").concat(token.antCls, "-btn"), {
    marginBottom: 0,
    marginInlineStart: token.marginXS
  })), _confirmComponentCls)), _defineProperty(_ref, "".concat(confirmComponentCls, "-error ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
    color: token.colorError
  }), _defineProperty(_ref, "".concat(confirmComponentCls, "-warning ").concat(confirmComponentCls, "-body > ").concat(token.iconCls, ",\n        ").concat(confirmComponentCls, "-confirm ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
    color: token.colorWarning
  }), _defineProperty(_ref, "".concat(confirmComponentCls, "-info ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
    color: token.colorInfo
  }), _defineProperty(_ref, "".concat(confirmComponentCls, "-success ").concat(confirmComponentCls, "-body > ").concat(token.iconCls), {
    color: token.colorSuccess
  }), _ref;
};
// ============================== Export ==============================
export default genSubStyleComponent(['Modal', 'confirm'], function (token) {
  var modalToken = prepareToken(token);
  return [genModalConfirmStyle(modalToken)];
}, prepareComponentToken, {
  // confirm is weak than modal since no conflict here
  order: -1000
});